// Globals and redux store init
import './configureGlobals';
import './FeatureFlags';
import './sidecar';
import '../httpClient/utils/Interceptors';
import '../app/InitReduxStore';
import '../contentDefinitions/populateContentDefinitionLookupLists';
import '../httpClient/utils/HttpClientTestHook';
import 'focus-visible/dist/focus-visible.min.js';
import 'url-search-params-polyfill';

import { VizService } from '~src/app/spaces/VizSpace/VizService';
import { startSessionPing } from '~src/root/utils/bootstrap';
import { mountReactApp } from '~src/root/utils/mountReactApp';

//TODO TFS 1302863- remove vizService instance creation from vizportal.ts and move it to relevant files
// Mount React app to DOM
const vizService = new VizService();
window.addEventListener('DOMContentLoaded', (event) => {
  mountReactApp(vizService);
});

// Initiate the getSessionInfo ping. This triggers login if user is not logged in already.
// also used to set admin account creation screen on fresh server
startSessionPing(vizService);